import { en } from '../translations/en.js';
import { th } from '../translations/th.js';
import { ja } from '../translations/ja.js';
import { zh } from '../translations/zh.js';

const translations = {
  en,
  th,
  ja,
  zh
};

// Helper function to get nested object properties by path
function getNestedValue(obj, path) {
  return path.split('.').reduce((current, key) => {
    return current && current[key] !== undefined ? current[key] : null;
  }, obj);
}

// Helper function to replace placeholders in strings
function replacePlaceholders(text, params = {}) {
  return text.replace(/\{(\w+)\}/g, (match, key) => {
    return params[key] !== undefined ? params[key] : match;
  });
}

export const translationService = {
  // Get translation for a specific key
  t(key, language = 'en', params = {}) {
    const translation = getNestedValue(translations[language] || translations.en, key);
    
    if (!translation) {
      // Fallback to English if translation not found
      const fallbackTranslation = getNestedValue(translations.en, key);
      if (!fallbackTranslation) {
        console.warn(`Translation key not found: ${key}`);
        return key;
      }
      return replacePlaceholders(fallbackTranslation, params);
    }
    
    return replacePlaceholders(translation, params);
  },

  // Get all available languages
  getAvailableLanguages() {
    return Object.keys(translations);
  },

  // Get language name in its native script
  getLanguageName(languageCode) {
    const languageNames = {
      en: 'English',
      th: 'ไทย',
      ja: '日本語',
      zh: '中文'
    };
    return languageNames[languageCode] || languageCode;
  },

  // Get all language options for dropdown
  getLanguageOptions() {
    return this.getAvailableLanguages().map(code => ({
      code,
      name: this.getLanguageName(code)
    }));
  },

  // Check if a translation exists
  hasTranslation(key, language = 'en') {
    return getNestedValue(translations[language] || translations.en, key) !== null;
  },

  // Get all translations for a specific key across all languages
  getAllTranslations(key) {
    const result = {};
    this.getAvailableLanguages().forEach(lang => {
      result[lang] = this.t(key, lang);
    });
    return result;
  }
}; 